import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/ReligionAssets.css';
import './styles/ReligionTints.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/i18n'; // ✅ Initialize i18n
import { captureAttribution } from './utils/attribution';

captureAttribution(); // remember which link brought the visitor (for the sign-ups by source report)

// Apply the cached authenticated theme before React's first paint. The auth
// request verifies it afterward; this prevents a default-theme flash.
const cachedReligion = localStorage.getItem('gettimelam_religion_theme');
document.documentElement.dataset.religion = ['hindu', 'christian', 'muslim'].includes(cachedReligion)
  ? cachedReligion
  : 'guest'; // no one logged in: the default palette

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
